'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

var _isNil = require('lodash/isNil');

var _isNil2 = _interopRequireDefault(_isNil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var SelectField = (_class = (_temp2 = _class2 = function (_React$Component) {
  (0, _inherits3.default)(SelectField, _React$Component);

  function SelectField() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SelectField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SelectField.__proto__ || Object.getPrototypeOf(SelectField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SelectField, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (!(0, _isEqual2.default)(prevProps.options, this.props.options)) {
        if ((0, _isNil2.default)(this.getValue())) {
          this.props.onChange(null);
        }
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(params) {
      var multi = this.props.multi;

      if (multi) {
        this.props.onChange(params.map(function (item) {
          return item.value;
        }));
      } else {
        if (params && !(0, _isNil2.default)(params.value)) {
          this.props.onChange(params.value);
        } else {
          this.props.onChange(null);
        }
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      var _props = this.props,
          value = _props.value,
          options = _props.options,
          multi = _props.multi;

      if (multi) {
        var selectedOptions = (value || []).map(function (optionValue) {
          return (options || []).find(function (option) {
            return option.value === optionValue;
          });
        });
        return selectedOptions.filter(function (option) {
          return !!option;
        });
      } else {
        var selectedOption = options.find(function (option) {
          return option.value === value;
        });
        if (!selectedOption) return null;
        return selectedOption;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var Component = this.props.component;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'label' },
          this.props.label
        ),
        _react2.default.createElement(Component, (0, _extends3.default)({
          id: 'justo-select',
          instanceId: 'justo-select',
          classNamePrefix: 'orion-select',
          isMulti: this.props.multi || this.props.isMulti,
          isClearable: this.props.isClearable,
          name: this.props.fieldName,
          value: this.getValue(),
          onChange: this.onChange,
          options: this.props.options,
          placeholder: this.props.placeholder
        }, this.props.passProps)),
        _react2.default.createElement(
          'div',
          { className: 'description' },
          this.props.description
        ),
        _react2.default.createElement(
          'div',
          { className: 'os-input-error' },
          this.props.errorMessage
        )
      );
    }
  }]);
  return SelectField;
}(_react2.default.Component), _class2.propTypes = {
  fieldName: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  value: _propTypes2.default.any,
  passProps: _propTypes2.default.object,
  errorMessage: _propTypes2.default.node,
  label: _propTypes2.default.node,
  description: _propTypes2.default.node,
  placeholder: _propTypes2.default.string,
  multi: _propTypes2.default.bool,
  options: _propTypes2.default.array,
  isClearable: _propTypes2.default.bool,
  component: _propTypes2.default.any
}, _class2.defaultProps = {
  options: [],
  isClearable: true,
  component: _reactSelect2.default
}, _temp2), (_applyDecoratedDescriptor(_class.prototype, 'onChange', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'onChange'), _class.prototype)), _class);
exports.default = SelectField;